module.exports = __webpack_public_path__ + "img/clown.8aecef2d.svg";